import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return ({
		container: {
			height: "100%",
			"& ihf-search .ihf-dropdown-menu.ihf-pt-3.ihf-show": {
				maxHeight: "calc(100vh - 136px) !important",
				overflowY: "scroll",
			},
		},
	} satisfies Record<string, CSSObject>);
}